import { render, staticRenderFns } from "./Trash.vue?vue&type=template&id=6d98d706&scoped=true"
import script from "./Trash.vue?vue&type=script&lang=js"
export * from "./Trash.vue?vue&type=script&lang=js"
import style0 from "./Trash.vue?vue&type=style&index=0&id=6d98d706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d98d706",
  null
  
)

export default component.exports